import React from 'react';
import { Typography } from '@material-ui/core';
import { medicalExamination } from '../../../../model/medicalexamination';
import moment from 'moment';

export const MexInfo = (props: { medicalExamination: medicalExamination, onClick: any, classes: any }) => {
    const { medicalExamination } = props;

    const onButtonClick = (mex: medicalExamination) => {
        console.log("onButtonClick uri:", mex.firebaseUri, mex._id)
        props.onClick(mex._id);
    };

    const winOpen = (mex: medicalExamination) => {
        window.open(mex.firebaseUri, mex.originalFileName, 'height=600,width=600');
    }

    const getName = (mex: medicalExamination) => {
        if (medicalExamination.nome !== null)
            return <><br />{medicalExamination.nome} {medicalExamination.cognome}</>
        return <><br />{medicalExamination.email}</>
    }

    return <div style={{ display: 'flex' }}>
        <Typography style={{ margin: '4px', paddingLeft: '0px' }}>caricato il<br />{moment(medicalExamination.medicalExaminationTimestamp).format("DD/MM/YYYY")} </Typography>
        {!medicalExamination.isValidateByGym && !medicalExamination.isDeleted && <Typography style={{ margin: '4px', paddingLeft: '10px' }}>
            <button onClick={() => onButtonClick(medicalExamination)}>VALIDA<br />DOCUMENTO</button>
        </Typography>}
        {!medicalExamination.isDeleted && <Typography style={{ margin: '4px', paddingLeft: '10px' }}>VALIDATO?<br />
            {medicalExamination.isValidateByGym ? "SI" : "NO"}</Typography>}
        {medicalExamination.isDeleted && <Typography style={{ margin: '4px', paddingLeft: '10px' }}>ELIMINATO</Typography>}
        {/* <Typography style={{ margin: '4px', paddingLeft: '10px' }}>valido dal<br />{moment(medicalExamination.validFrom).format('DD/MM/YYYY')}</Typography> */}
        {/* <Typography style={{ margin: '4px', paddingLeft: '10px' }}>scade il<br />{moment(medicalExamination.expiresOn).format("DD/MM/YYYY")}</Typography> */}
        <Typography style={{ margin: '4px', paddingLeft: '10px' }}>
            {medicalExamination.sub}
            <b>{getName(medicalExamination)}</b>
        </Typography>
        <Typography style={{ margin: '4px', paddingLeft: '10px' }}>
            <a style={{ cursor: 'pointer' }} onClick={() => { winOpen(medicalExamination) }} href={medicalExamination.firebaseUri} target='_blank' rel='noopener noreferrer'>{medicalExamination.originalFileName}.{medicalExamination.extension}</a>
        </Typography>
        {/* <Typography style={{ margin: '4px', paddingLeft: '10px' }}>note<br />{medicalExamination.notes}</Typography> */}
    </div>
}